import { useEffect } from 'react';

import { setUTMCookie } from '@utils/cookieUTMParamUtils';

export const useUTMParams = (): void => {
  useEffect(() => {
    setUTMCookie();
  }, []);
};
